type EventParams = Record<string, string | number | boolean | null | undefined>;

declare global {
  interface Window {
    gtag?: (...args: any[]) => void;
  }
}

export const trackEvent = (eventName: string, params?: EventParams): void => {
  if (typeof window === 'undefined') return;
  if (typeof window.gtag !== 'function') return;
  window.gtag('event', eventName, params || {});
};

export const trackUpgradeClick = (source: string, action: string = 'click'): void => {
  trackEvent('upgrade_click', {
    source,
    action,
  });
};
